import React, { useState, useEffect } from 'react';
import { fetchFreelancerJobImages } from '../../../../services/freelancerService';
import { getImage } from '../../../../utils/cloudinarySizing';

const FreelancerPhotos = ({ freelancerId }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [fullResSrc, setFullResSrc] = useState(null);


  const fetchPhotos = async () => {
    try {
      const response = await fetchFreelancerJobImages(freelancerId);
      setPhotos(response || []);
    } catch (error) {
      console.error("Error fetching freelancer images:", error);
      setPhotos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!freelancerId) return;
    fetchPhotos();
  }, [freelancerId]);

  if (loading) return null;

  const handleClickPhoto = (photo) => {
    setSelectedPhoto(photo?.image);

    const preview = photo?.image || getImage(photo);
    setFullResSrc(preview);

    if (photo?.image) {
      const img = new Image();
      img.src = photo.image;
      img.onload = () => setFullResSrc(photo.image);
      img.onerror = () => setFullResSrc(preview);
    }
  };

  return (
    <div>
      <p
        style={{
          color: "var(--text)",
          textAlign: photos.length === 0 ? "center" : "right",
          ...(photos.length === 0 && { marginTop: "20px" }),
        }}
      >
        {photos.length === 0
          ? "No Images"
          : `${photos.length} ${photos.length === 1 ? "Image" : "Images"}`}
      </p>

      <div className="photos-section-freelancer">
        <div className="photo-container">
          {photos.map((photo) => {
            const src = getImage(photo?.image, "job_med");

            return (
              <div className="photo-box" key={photo.id}>
                <img
                  src={src}
                  alt={`Job Photo ${photo.id}`}
                  onClick={() => handleClickPhoto(photo)}
                  onError={(e) => {
                    e.currentTarget.src = null;
                  }}
                />

                <p className="review-date">
                  {new Date(photo.created_at).toLocaleString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {selectedPhoto && (
        <div
          className="lightbox-backdrop"
          onClick={() => setSelectedPhoto(null)}
        >
          <img
            src={fullResSrc || getImage(selectedPhoto)}
            alt="Full Size"
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FreelancerPhotos;